import React, { FC, useEffect, useState } from 'react'
import _ from 'lodash'
// lib
import { isValidDate, parseDate } from 'data/lib/dates.ts'
// styles
import { Dropdown_s, InputText_s } from 'styles/input-styles'
import { Label_s } from 'styles/app-styles'
import { DateText_s } from 'styles/report-styles'
// types
import { FolderReportProps, ReportFormParameters } from './reports'

type ReportType = 'folder_expirations'
const displayName = 'Expiration'

type Inclusion = 'all_terms' | 'last_option' | 'base_options' | 'base_tenants'
type ExpirationReportParameters = ReportFormParameters & {
  begindate: string // MM/DD/YYYY
  inclusion: Inclusion
  report: ReportType
  term: number
}

export const propertyFilter = (property) => property.type === 'Commercial'

export const Expiration: FC<FolderReportProps> = (props) => {
  const [inclusion, updateInclusion] = useState<Inclusion>('all_terms')
  const [startdate, setStartDate] = useState<string>(props.reportbegindate)
  const [term, setTerm] = useState<number>(props.term)
  const [termOnce, setTermOnce] = useState<boolean>(false)

  const inclusionOptions = [
    { text: 'All Terms', value: 'all_terms' },
    { text: 'Base Tenant or Last Option', value: 'last_option' },
    { text: 'Base Tenants and Options', value: 'base_options' },
    { text: 'Base Tenants', value: 'base_tenants' }
  ]

  if (!term && props.term && !termOnce) {
    setTerm(props.term)
    setTermOnce(true)
  }

  useEffect(() => {
    const valid = isValidDate(startdate) && !_.isNil(term) && term >= 3

    props.setParameters(getParameters())
    props.setValid(valid)
  }, [inclusion, startdate, term])

  function getParameters(): ExpirationReportParameters {
    return {
      begindate: startdate,
      inclusion,
      report: 'folder_expirations',
      term: +term
    }
  }

  return (
    <>
      <div>
        <Label_s>Start Date</Label_s>
        <DateText_s
          value={parseDate(startdate).format('MM/DD/YYYY')}
          onChange={setStartDate}
          onBlur={setStartDate}
          persist={setStartDate}
          withoutDays
        />
      </div>
      <div>
        <Label_s>Term</Label_s>
        <InputText_s
          keyfilter="pnum"
          onChange={(e) => setTerm(e.target.value)}
          value={term}
        />
      </div>
      <div>
        <Label_s>Include Lease Terms</Label_s>
        <Dropdown_s
          onChange={(e) => updateInclusion(e.value)}
          optionLabel="text"
          options={inclusionOptions}
          value={inclusion}
          wide
        />
      </div>
    </>
  )
}

Expiration.displayName = displayName
